module.exports = __webpack_public_path__ + "img/VN.6a8e16c8.svg";